package com.narbase.letsgo.web.views.searchIndex

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.areas.AreaDto
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto
import com.narbase.letsgo.web.dto.zones.PriceZoneDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.GetFavoritePointsSearchStatusEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.ReindexFavoritePointsSearchEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.GetPointsOfInterestSearchStatusEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.ReindexPointsOfInterestSearchEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.SearchPointsOfInterestEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.UpdateElasticsearchSettingsEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class SearchIndexManagementViewModel {

    val getStatusUiState = Observable<BasicUiState>()
    val reindexUiState = Observable<BasicUiState>()
    val getFavoritePointsStatusUiState = Observable<BasicUiState>()
    val reindexFavoritePointsUiState = Observable<BasicUiState>()
    val searchUiState = Observable<BasicUiState>()
    val updateSettingsUiState = Observable<BasicUiState>()

    var status: GetPointsOfInterestSearchStatusEndpoint.Response? = null
    var lastIndexedPointsCount: Int? = null

    var favoritePointsStatus: GetFavoritePointsSearchStatusEndpoint.Response? = null
    var lastIndexedFavoritePointsCount: Int? = null

    var points: List<LocationPointDto> = listOf()
    var searchTerm = ""
    var includeAddress = true
    var areaFilter: AreaDto? = null
    var priceZoneFilter: PriceZoneDto? = null
    var pageNo = 0
    var pageSize = 20

    val isLastPageEmpty: Boolean
        get() = points.size < pageSize

    fun getStatus() {
        basicNetworkCall(getStatusUiState) {
            val dto = GetPointsOfInterestSearchStatusEndpoint.Request()
            status = GetPointsOfInterestSearchStatusEndpoint.remoteProcess(dto).data
        }
    }

    fun reindex() {
        basicNetworkCall(reindexUiState) {
            val dto = ReindexPointsOfInterestSearchEndpoint.Request()
            val response = ReindexPointsOfInterestSearchEndpoint.remoteProcess(dto).data
            lastIndexedPointsCount = response.indexedPointsCount
        }
    }

    fun setReindexUiStateToNull() {
        reindexUiState.value = null
    }

    fun getFavoritePointsStatus() {
        basicNetworkCall(getFavoritePointsStatusUiState) {
            val dto = GetFavoritePointsSearchStatusEndpoint.Request()
            favoritePointsStatus = GetFavoritePointsSearchStatusEndpoint.remoteProcess(dto).data
        }
    }

    fun reindexFavoritePoints() {
        basicNetworkCall(reindexFavoritePointsUiState) {
            val dto = ReindexFavoritePointsSearchEndpoint.Request()
            val response = ReindexFavoritePointsSearchEndpoint.remoteProcess(dto).data
            lastIndexedFavoritePointsCount = response.indexedFavoritePointsCount
        }
    }

    fun setReindexFavoritePointsUiStateToNull() {
        reindexFavoritePointsUiState.value = null
    }

    fun updateSettings(isActive: Boolean, url: String) {
        basicNetworkCall(updateSettingsUiState) {
            val dto = UpdateElasticsearchSettingsEndpoint.Request(isActive = isActive, url = url)
            UpdateElasticsearchSettingsEndpoint.remoteProcess(dto)
        }
    }

    fun setUpdateSettingsUiStateToNull() {
        updateSettingsUiState.value = null
    }

    fun searchPoints() {
        basicNetworkCall(searchUiState) {
            val dto = SearchPointsOfInterestEndpoint.Request(
                pageNo = pageNo,
                pageSize = pageSize,
                searchTerm = searchTerm,
                includeAddress = includeAddress,
                areaId = areaFilter?.id,
                priceZoneId = priceZoneFilter?.id,
            )
            val response = SearchPointsOfInterestEndpoint.remoteProcess(dto).data
            points = response.passengerDestinations.toList()
        }
    }

    fun searchFor(term: String) {
        pageNo = 0
        searchTerm = term
        searchUiState.value = BasicUiState.Loaded
        searchPoints()
    }

    fun setIncludeAddress(value: Boolean) {
        includeAddress = value
        pageNo = 0
        searchPoints()
    }

    fun setAreaFilter(area: AreaDto?) {
        areaFilter = area
        pageNo = 0
        searchPoints()
    }

    fun setPriceZoneFilter(priceZone: PriceZoneDto?) {
        priceZoneFilter = priceZone
        pageNo = 0
        searchPoints()
    }

    fun getNextPage() {
        pageNo++
        searchPoints()
    }

    fun getPreviousPage() {
        if (pageNo == 0) return
        pageNo--
        searchPoints()
    }
}
